/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:50:03
 * @Last Modified by: Felixx
 * @Last Modified time: 2021-07-14 00:05:37
 */
import utils from '@/app/utils/gfUtils';
import { svg } from '@/app/editor/sidebar/utils/actions.assets';
import store from '@/app/store/store';

type TypeDesignOption = {
  iconButtonResponsive: string;
};

/**
 * ...
 * @param data
 */
const positioning = (data: TypeDesignOption): string => {
  if (store.getValue('__shop').plan == 'starter') {
    return `<div class="columns design-options_positioning" data-advanced="true" data-caption="Position" data-responsive="false" data-hover="true" data-toggle="false">
      <div class="gfSGBackground"></div>
      <div class="gfSettingGroup">
        <div class="gfSGBarHover">
          <div class="gfSGBarHoverTitle">
            <svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
              <path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/>
            </svg>
          </div>
          <button type="button" class="gfSGBarHoverIcon">
            <svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
              <path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/>
            </svg>
          </button>
        </div>
        <div class="gfSGTitleBar d-flex align-items-center justify-content-between show-popup-plan">
          <div class="gfSGTitleBarTitle p-0">Position</div>
          <div class="d-flex align-items-center" v-if="isNotBusiness">
            <p class="txt-primary-400 drop-down__plan ml-4px">Build</p>
          </div>
        </div>
        <div class="gfSGResponsive"></div>
      </div>
    </div>`;
  }
  return `<div class="columns design-options_positioning" data-advanced="true" data-caption="Position" data-responsive="false" data-hover="true" data-toggle="false">
  <div class="gfSGBackground"></div>
  <div class="gfSettingGroup">
    <div class="gfSGBarHover">
      <div class="gfSGBarHoverTitle">
        <svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
          <path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/>
        </svg>
      </div>
      <button type="button" class="gfSGBarHoverIcon">
        <svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
          <path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/>
        </svg>
      </button>
    </div>
    <div class="gfSGTitleBar">
      <div class="gfSGTitleBarTitle">Position</div>
    </div>
    <div class="gfSGSettings">
      <span class="gfDesc" reference="" targetclass="" style="">
        <a href="#" class="reference">Advanced option</a>: Please proceed if you have coding knowledge.
      </span>
      <select reference="css|position" id="position" name="position" data-name="position" data-disable="false" class="gf-position" data-caption="Position" default_value="">
        <option value="relative">Relative</option>  
        <option value="fixed">Sticky to the screen (Fixed)</option>
        <option value="static">Static</option>
      </select>
      <input type="text" requires="position|fixed:relative" reference="css|z-index" id="z-index" name="z-index" data-name="z-index" class="" unit="" max="2147483647" value="0" default_value="0" data-caption="Z-Index" data-description="" />
    </div>
  </div>
</div>
<div class="columns-advanced" data-hide="true" data-responsive="true" data-hover="true" data-toggle="false">
  <div class="gfSGBackground"></div>
  <div class="gfSettingGroup">
    <div class="gfSGBarHover">
      <div class="gfSGBarHoverTitle">
        <svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
          <path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D ;"/>
        </svg>
      </div>
      <button type="button" class="gfSGBarHoverIcon">
        <svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
          <path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D ;"/>
        </svg>
      </button>
    </div>
    <div class="gfSGTitleBar">
      <div class="gfSGTitleBarTitle">Positioning</div>
      <button type="button" class="gfSGTitleBarResposive">
        ${data.iconButtonResponsive}
      </button>
    </div>
    <div class="gfSGResponsive"></div>
    <div class="gfSGSettings">
    <input type="text" requires="position|fixed:relative" id="v-gravity" data-name="v-gravity" class="" name="gravity" data-direction="vertical" data-hide="false" data-type="hidden" data-alpha="true"/>
    <input type="text" name="v-offset" data-name="v-offset" id="v-offset" class="gf-field-item" targetclass="" value="" default_value="" data-description="" unit="px" data-unit="%,px" placeholder="auto" data-caption="Offset">
    
    <input type="text" requires="position|fixed:relative" id="h-gravity" data-name="h-gravity" class="" name="gravity" data-direction="horizontal" data-hide="false" data-type="hidden" data-alpha="true"/>
    <input type="text" name="h-offset" data-name="h-offset" id="h-offset" class="gf-field-item" targetclass="" value="" default_value="" data-description="" unit="px" data-unit="%,px" placeholder="auto" data-caption="Offset"></div>
  </div>
</div>`;
};

/**
 * Template for Design Options
 * @param data TypeDesignOption
 * @returns return template text
 */
export const template = (data: TypeDesignOption): string => {
  return `
<div class="design-options">
	<div class="columns" data-caption="Visibility" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGBarHover">
				<div class="gfSGBarHoverTitle">
					<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
						<path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/>
					</svg>
				</div>
				<button type="button" class="gfSGBarHoverIcon">
					<svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
						<path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/>
					</svg>
				</button>
			</div>
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle">Visibility</div>
			</div>
			<div class="gfSGResponsive"></div>
			<div class="gfSGSettings">
				<input type="text" data-name="display" name="display" id="display" class="gf_field-display" value="0|0|0|0" data-value="Desktop,Laptop,Tablet,Mobile" default_value="Desktop,Laptop,Tablet,Mobile" data-tooltips="Hide Desktop,Hide Laptop,Hide Tablet, Hide Mobile" data-multiple="true" data-type="visibility"/>
			</div>
		</div>
	</div>
	<div class="columns" data-caption="Spacing" data-responsive="true" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGBarHover">
				<div class="gfSGBarHoverTitle">
					<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
						<path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/>
					</svg>
				</div>
				<button type="button" class="gfSGBarHoverIcon">
					<svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
						<path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/>
					</svg>
				</button>
			</div>
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle">Spacing</div>
				<button type="button" class="gfSGTitleBarResposive">
					${data.iconButtonResponsive}
				</button>
			</div>
			<div class="gfSGResponsive"></div>
			<div class="gfSGSettings">
				<div class="gfSGSubTitle">Margin</div>
				<div class="gf_margin-wrapper">
					<div class="gf_margin-top">
						${utils.svgIcon('margin-top')}
						<input type="text" reference="css|margin-top" name="margin-top" data-name="margin-top" data-group="margin" unconstraint="1" class="gf_margin" value="" placeholder="0"/>
					</div>
					<div class="gf_margin-right">
            ${utils.svgIcon('margin-right')}
						<input type="text" reference="css|margin-right" name="margin-right" data-name="margin-right" data-group="margin" unconstraint="1" class="gf_margin" value="" placeholder="0"/>
					</div>
					<div class="gf_margin-bottom">
            ${utils.svgIcon('margin-bottom')}
						<input type="text" reference="css|margin-bottom" name="margin-bottom" data-name="margin-bottom" data-group="margin" unconstraint="1" class="gf_margin" value="" placeholder="0"/>
					</div>
					<div class="gf_margin-left">
            ${utils.svgIcon('margin-left')}
						<input type="text" reference="css|margin-left" name="margin-left" data-name="margin-left" data-group="margin" unconstraint="1" class="gf_margin" value="" placeholder="0"/>
					</div>
					<span class="gf_gs-action-mode unconstraint" data-group="margin">
						${utils.svgIcon('margin')}
					</span>
				</div>
				<div class="gfSGSubTitle">Padding</div>
				<div class="gf_padding-wrapper">
					<div class="gf_padding-top">
						${utils.svgIcon('padding-top')}
						<input type="text" reference="css|padding-top" name="padding-top" data-name="padding-top" data-group="padding" unconstraint="1" class="gf_padding" value="" placeholder="0"/>
					</div>
					<div class="gf_padding-right">
						${utils.svgIcon('padding-right')}
						<input type="text" reference="css|padding-right" name="padding-right" data-name="padding-right" data-group="padding" unconstraint="1" class="gf_padding" value="" placeholder="0"/>
					</div>
					<div class="gf_padding-bottom">
						${utils.svgIcon('padding-bottom')}
						<input type="text" reference="css|padding-bottom" name="padding-bottom" data-name="padding-bottom" data-group="padding" unconstraint="1" class="gf_padding" value="" placeholder="0"/>
					</div>
					<div class="gf_padding-left">
						${utils.svgIcon('padding-left')}
						<input type="text" reference="css|padding-left" name="padding-left" data-name="padding-left" data-group="padding" unconstraint="1" class="gf_padding" value="" placeholder="0"/>
					</div>
					<span class="gf_gs-action-mode unconstraint" data-group="padding">
						${utils.svgIcon('padding')}
					</span>
				</div>
			</div>
		</div>
	</div>
	<div class="columns" data-advanced="true" data-caption="Background" data-responsive="true" data-hover="true" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGBarHover">
				<div class="gfSGBarHoverTitle">
					<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
						<path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/>
					</svg>
				</div>
				<button type="button" class="gfSGBarHoverIcon">
					<svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
						<path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/>
					</svg>
				</button>
			</div>
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle">Background</div>
				<button type="button" class="gfSGTitleBarResposive">
					${data.iconButtonResponsive}
				</button>
			</div>
			<div class="gfSGResponsive"></div>
			<div class="gfSGSettings">
				<input type="text" class="gryff-color" name="background-v2" data-name="background-v2" data-hide="false" data-type="hidden" data-alpha="true"/>
				<input type="text" reference="css|background-color" requires="background-v2|color" name="background-color" data-name="background-color" class="gryff-color" data-caption="Color" data-type="hidden" data-alpha="true"/>
				<input type="text" reference="css|background-image" name="background-image" requires="background-v2|image" data-caption="Image" data-name="background-image" class="gf_to-photoPicker"/>
			</div>
		</div>
	</div>
	<div class="columns-advanced" data-hide="true" requires="background-v2|image" data-responsive="true" data-hover="true" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGBarHover">
				<div class="gfSGBarHoverTitle">
					<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
						<path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/>
					</svg>
				</div>
				<button type="button" class="gfSGBarHoverIcon">
					<svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
						<path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/>
					</svg>
				</button>
			</div>
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle">Background</div>
				<button type="button" class="gfSGTitleBarResposive">
					${data.iconButtonResponsive}
				</button>
			</div>
			<div class="gfSGResponsive"></div>
			<div class="gfSGSettings">
				<input class="gf_to-segment" reference="css|background-size" name="background-size" data-name="background-size" data-caption="Background Size" data-value="cover,contain" data-columns="Cover,Contain"/>
				<input class="gf_to-backgroundPosition" reference="css|background-position" name="background-position" data-name="background-position" data-caption="Background Position" value="0% 0%"/>
				<input class="gf_to-segment" reference="css|background-position" name="background-repeat" name="background-repeat" data-name="background-repeat" data-caption="Background Repeat" data-value="repeat,repeat-x,repeat-y,no-repeat" data-columns="icon-repeatXY,icon-repeatX,icon-repeatY,icon-norepeat" data-icon="true" data-tooltips="Repeat X & Y,Repeat X,Repeat Y,No repeat"/>
				<input class="gf_to-segment" reference="css|background-position" name="background-attachment" name="background-attachment" data-name="background-attachment" data-caption="Background Attachment" data-value="scroll,fixed,local" data-columns="Scroll,Fixed,Local"/>
			</div>
		</div>
	</div>
	<div class="columns" data-advanced="true" data-caption="Border" data-responsive="true" data-hover="true" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGBarHover">
				<div class="gfSGBarHoverTitle">
					<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
						<path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/>
					</svg>
				</div>
				<button type="button" class="gfSGBarHoverIcon">
					<svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
						<path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/>
					</svg>
				</button>
			</div>
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle" data-caption="Border">Border</div>
				<button type="button" class="gfSGTitleBarResposive">
					${data.iconButtonResponsive}
				</button>
			</div>
			<div class="gfSGResponsive"></div>
			<div class="gfSGSettings">
				<input class="gf_to-segment" reference="css|border-style" name="border-style" name="border-style" data-name="border-style" data-caption="Border Design" data-value="none,solid,dashed,dotted" data-columns="icon-noborder,icon-borderSolid,icon-borderDashed,icon-borderDotted" data-icon="true" data-tooltips="No border,Solid,Dashed,Dotted"/>
				<input type="text" reference="css|border-color" name="border-color" data-name="border-color" data-caption="Border Color" class="gryff-color" data-type="hidden" data-hide="true" data-alpha="true"/>
				<input type="text" reference="css|border-width" name="border-width" data-name="border-width" data-caption="Border Thickness" class="gf-border-width" unit="px" min="0" max="100" step="1" default_value="0" value=""/>
			</div>
		</div>
	</div>
	<div class="columns-advanced" data-hide="true" data-responsive="true" data-hover="true" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGBarHover">
				<div class="gfSGBarHoverTitle">
					<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
						<path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/>
					</svg>
				</div>
				<button type="button" class="gfSGBarHoverIcon">
					<svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
						<path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/>
					</svg>
				</button>
			</div>
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle">Border</div>
				<button type="button" class="gfSGTitleBarResposive">
					${data.iconButtonResponsive}
				</button>
			</div>
			<div class="gfSGResponsive"></div>
			<div class="gfSGSettings">
				<div class="gfSGSubTitle">
					<div class="gfSGclear"></div>Width (px)
				</div>
				<div class="gfBorderWidth">
					<div class="border-top-width">
						${utils.svgIcon('margin-top')}
						<input type="text" reference="css|border-top-width" name="border-top-width" data-name="border-top-width" class="gf_border-width" value="" unit="px" placeholder="0"/>
					</div>
					<div class="border-right-width">
						${utils.svgIcon('margin-right')}
						<input type="text" reference="css|border-right-width" name="border-right-width" data-name="border-right-width" class="gf_border-width" value="" unit="px" placeholder="0"/>
					</div>
					<div class="border-bottom-width">
						${utils.svgIcon('margin-bottom')}
						<input type="text" reference="css|border-bottom-width" name="border-bottom-width" data-name="border-bottom-width" class="gf_border-width" value="" unit="px" placeholder="0"/>
					</div>
					<div class="border-left-width">
						${utils.svgIcon('margin-left')}
						<input type="text" reference="css|border-left-width" name="border-left-width" data-name="border-left-width" class="gf_border-width" value="" unit="px" placeholder="0"/>
					</div>
					<span class="gf_gs-action-mode">
						${utils.svgIcon('border-width')}
					</span>
				</div>
			</div>
		</div>
	</div>
	<div class="columns" data-caption="Corner" data-responsive="true" data-hover="true" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGBarHover">
				<div class="gfSGBarHoverTitle">
					<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
						<path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/>
					</svg>
				</div>
				<button type="button" class="gfSGBarHoverIcon">
					<svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
						<path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/>
					</svg>
				</button>
			</div>
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle" data-caption="Corner">Corner</div>
				<button type="button" class="gfSGTitleBarResposive">
					${data.iconButtonResponsive}
				</button>
			</div>
			<div class="gfSGResponsive"></div>
			<div class="gfSGSettings">
				<div class="gfSGSubTitle" data-caption="Radius">
					<div class="gfSGclear"></div>Radius (px)
				</div>
				<div class="gfBorderRadius">
					<div class="border-top-left-radius">
						${utils.svgIcon('border-radius-top-left')}
						<input type="text" reference="css|border-top-left-radius" name="border-top-left-radius" data-name="border-top-left-radius" unconstraint="0" class="gf_border-radius" value="" unit="px" placeholder="0"/>
					</div>
					<div class="border-top-right-radius">
						${utils.svgIcon('border-radius-top-right')}
						<input type="text" reference="css|border-top-right-radius" name="border-top-right-radius" data-name="border-top-right-radius" unconstraint="0" class="gf_border-radius" value="" unit="px" placeholder="0"/>
					</div>
					<div class="border-bottom-left-radius">
						${utils.svgIcon('border-radius-bottom-left')}
						<input type="text" reference="css|border-bottom-left-radius" name="border-bottom-left-radius" data-name="border-bottom-left-radius" unconstraint="0" class="gf_border-radius" value="" unit="px" placeholder="0"/>
					</div>
					<div class="border-bottom-right-radius">
						${utils.svgIcon('border-radius-bottom-right')}
						<input type="text" reference="css|border-bottom-right-radius" name="border-bottom-right-radius" data-name="border-bottom-right-radius" unconstraint="0" class="gf_border-radius" value="" unit="px" placeholder="0"/>
					</div>
					<span class="gf_gs-action-mode" data-group="border">
						${utils.svgIcon('border-radius')}
					</span>
				</div>
			</div>
		</div>
	</div>
	<div class="columns" data-advanced="true" data-caption="Shadow" data-responsive="true" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGBarHover">
				<div class="gfSGBarHoverTitle">
					<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
						<path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D ;"/>
					</svg>
				</div>
				<button type="button" class="gfSGBarHoverIcon">
					<svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
						<path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D ;"/>
					</svg>
				</button>
			</div>
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle">Shadow</div>
				<button type="button" class="gfSGTitleBarResposive">
					${data.iconButtonResponsive}
				</button>
			</div>
			<div class="gfSGResponsive"></div>
			<div class="gfSGSettings">
				<input type="text" reference="css|box-shadow-style" name="box-shadow-style" data-name="box-shadow-style" data-disable="true" class="gf-shadow-style" data-caption="Shadow Style" data-value="drop,outer" data-columns="Drop Shadow,Outer Shadow" data-tooltips="Shadow Drop,Shadow Outer"/>
				<input type="text" reference="css|box-shadow-color" name="box-shadow-color" data-name="box-shadow-color" class="gryff-color" data-caption="Shadow Color" data-type="hidden" data-hide="true" data-alpha="true"/>
			</div>
		</div>
	</div>
	<div class="columns-advanced" data-hide="true" data-responsive="true" data-hover="true" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGBarHover">
				<div class="gfSGBarHoverTitle">
					<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
						<path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D ;"/>
					</svg>
				</div>
				<button type="button" class="gfSGBarHoverIcon">
					<svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
						<path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D ;"/>
					</svg>
				</button>
			</div>
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle">Shadow</div>
				<button type="button" class="gfSGTitleBarResposive">
					${data.iconButtonResponsive}
				</button>
			</div>
			<div class="gfSGResponsive"></div>
			<div class="gfSGSettings">
				<input type="text" reference="css|box-shadow-type" name="box-shadow-type" data-name="box-shadow-type" class="gf_to-segment" data-caption="Shadow Type" data-value="inset,outset" data-columns="INSET,OUTSET" data-disable="false"/>
				<input type="text" name="box-shadow-angle" reference="css|box-shadow-angle" data-caption="Shadow Angle" data-name="box-shadow-angle" value="135"/>
				<input type="text" name="box-shadow-distance" reference="css|box-shadow-distance" data-name="box-shadow-distance" class="gf_to-range" min="0" max="100" step="1" unit="px" value="0" default_value="0" data-caption="Shadow Distance"/>
				<input type="text" reference="css|box-shadow-blur" name="box-shadow-blur" data-name="box-shadow-blur" class="gf_to-range" min="0" max="100" step="1" unit="px" value="0px" style="display: none;" data-caption="Shadow Blur"/>
				<input type="text" reference="css|box-shadow-spread" name="box-shadow-spread" data-name="box-shadow-spread" class="gf_to-range" min="-100" max="100" step="1" unit="px" value="0px" style="display: none;" data-caption="Shadow Size"/>
			</div>
		</div>
	</div>

	<div class="columns" data-caption="Opacity" data-responsive="true" data-hover="true" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGBarHover">
				<div class="gfSGBarHoverTitle">
					<svg class="help-me-name-it-bruh" height="5px" viewBox="0 0 29 5">
						<path d="M13,0v4h-1V0H13z M6,0h5v5H6V0z M7,4h3V1H7V4z M13,5h3V4h-3V5z M16,4h1V0h-1V4z M4,2H1V0H0v5h1V3h3v2h1V0H4V2zM28,3v1h-1V3h-2v2h-1V0h1h3h1v3H28z M28,2V1h-3v1H28z M29,5V4h-1v1H29z M23,1V0h-5v5h5V4h-4V3h4V2h-4V1H23z" style="fill: #2A2A2D;"/>
					</svg>
				</div>
				<button type="button" class="gfSGBarHoverIcon">
					<svg class="help-me-name-it-bruh" height="11px" viewBox="0 0 7 11">
						<path d="M4,5h1v4H4V5z M2,9h1V5H2V9z M7,3v8H0V3H7z M1,10h5V4H1V10z M4,1V0H3v1H0v1h7V1H4z" style="fill: #2A2A2D;"/>
					</svg>
				</button>
			</div>
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle">Opacity</div>
				<button type="button" class="gfSGTitleBarResposive">
					${data.iconButtonResponsive}
				</button>
			</div>
			<div class="gfSGResponsive"></div>
			<div class="gfSGSettings">
				<input type="text" reference="css|opacity" name="opacity" data-name="opacity" class="gf_to-range" min="0.2" max="1" step="0.1" unit="" value="1" default_value="1" data-description=""/>
			</div>
		</div>
	</div>

  ${positioning(data)}

	<div class="columns" data-caption="Interactions" data-hover="true" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle">Animations (beta)</div>
				<button type="button" class="gfSGTitleBar">
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#clip0)">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M10.4169 3.58258C8.16128 3.58258 6.33276 5.4111 6.33276 7.66669C6.33276 9.92228 8.16128 11.7508 10.4169 11.7508C12.6725 11.7508 14.501 9.92228 14.501 7.66669C14.501 5.4111 12.6725 3.58258 10.4169 3.58258ZM4.83276 7.66669C4.83276 4.58267 7.33286 2.08258 10.4169 2.08258C13.5009 2.08258 16.001 4.58267 16.001 7.66669C16.001 10.7507 13.5009 13.2508 10.4169 13.2508C7.33286 13.2508 4.83276 10.7507 4.83276 7.66669Z" fill="#D6D6D6"/>
					<path fill-rule="evenodd" clip-rule="evenodd" d="M5.58289 3.58258C5.25335 3.58258 4.93388 3.62146 4.62842 3.69454L4.27939 2.23571C4.69832 2.13548 5.13492 2.08258 5.58289 2.08258C5.86218 2.08258 6.13713 2.10314 6.4062 2.14295L6.18667 3.6268C5.99004 3.59771 5.78846 3.58258 5.58289 3.58258ZM7.51809 4.06911C7.34163 3.97395 7.15747 3.89146 6.96679 3.8228L7.47499 2.41151C7.73635 2.50562 7.98859 2.61863 8.23006 2.74884L7.51809 4.06911ZM3.44925 4.18342C2.90025 4.52056 2.43676 4.98405 2.09962 5.53305L0.821397 4.74811C1.28191 3.9982 1.9144 3.36571 2.66431 2.9052L3.44925 4.18342ZM1.61074 6.71222C1.53766 7.01768 1.49878 7.33715 1.49878 7.66669C1.49878 7.99623 1.53766 8.31571 1.61074 8.62116L0.151912 8.97019C0.0516798 8.55126 -0.0012207 8.11466 -0.0012207 7.66669C-0.0012207 7.21872 0.0516798 6.78212 0.151912 6.36319L1.61074 6.71222ZM2.09962 9.80033C2.43676 10.3493 2.90025 10.8128 3.44925 11.15L2.66431 12.4282C1.9144 11.9677 1.28191 11.3352 0.821397 10.5853L2.09962 9.80033ZM6.95702 11.5141C7.14646 11.4464 7.32952 11.3651 7.50501 11.2713L8.21216 12.5942C7.972 12.7225 7.72127 12.8339 7.46159 12.9267L6.95702 11.5141ZM4.62842 11.6388C4.93388 11.7119 5.25335 11.7508 5.58289 11.7508C5.78693 11.7508 5.98703 11.7359 6.18226 11.7072L6.40017 13.1913C6.13302 13.2305 5.86009 13.2508 5.58289 13.2508C5.13492 13.2508 4.69832 13.1979 4.27939 13.0977L4.62842 11.6388Z" fill="#D6D6D6"/>
					</g>
					<defs>
					<clipPath id="clip0">
					<rect width="16" height="16" fill="white"/>
					</clipPath>
					</defs>
				</svg>
				</button>
			</div>
		</div>
	</div>
	<div class="columns" data-caption="Flow Actions" data-hover="true" data-toggle="false">
		<div class="gfSGBackground"></div>
		<div class="gfSettingGroup">
			<div class="gfSGTitleBar">
				<div class="gfSGTitleBarTitle">Flow Actions (beta)</div>
				<button type="button" class="gfSGTitleBar">
				${svg('flowActionsIcon')}
				</button>
			</div>
		</div>
	</div>
</div>
  `;
  // <input type="text" requires="position|fixed" name="width" id="width" data-name="width" class="gf-field-item" reference="css|width" targetclass="" value="auto" default_value="100%" data-description="" unit="px" data-unit="%,px,vw" placeholder="auto" data-caption="Width">
  // <option value="initial">Inherit from browser</option>
  // <option value="inherit">Inherit from parent</option>
  // <option value="static">Static</option>
  // <option value="absolute">Absolute</option>
};
